import { useMemo } from "react";
import { css, Theme, SerializedStyles } from "@emotion/react";
import { useTheme } from "@emotion/react";

type StyleElement =
  | Record<string, Record<string, any>>
  | ((theme: Theme, dynamicStyles?: {}) => Record<string, Record<string, any>>);

const useCustomStyles = (
  stylesElement: StyleElement | Function,
  dynamicStyles?: {}
): Record<string, SerializedStyles> => {
  const theme = useTheme();

  return useMemo(() => {
    const rawClasses =
      typeof stylesElement === "function"
        ? stylesElement(theme, { ...dynamicStyles })
        : stylesElement;

    const prepared: Record<string, SerializedStyles> = {};

    Object.entries(rawClasses).forEach(([key, value = {}]) => {
      const styles: SerializedStyles = css(value as TemplateStringsArray, {
        label: key,
      });

      prepared[key] = styles;
    });

    return prepared;
  }, [stylesElement, theme, dynamicStyles]);
};

export default useCustomStyles;
